export default __webpack_public_path__ + "static/media/a.65e08c3e.mp4";